import { Button, ButtonMode, ButtonSize } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../Base.constants';
import styles from './NotFound.module.scss';

const cx = classNames.bind(styles);

interface NotFoundProps {
  showNavigateToFeeds?: boolean;
  smaller?: boolean;
  fullWidth?: boolean;
}

const NotFound = ({
  showNavigateToFeeds = true,
  smaller = false,
  fullWidth = false,
}: NotFoundProps): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <div className={cx('body', { 'is-smaller': smaller, 'is-full-size': fullWidth })}>
      <div className={cx('text-box')}>
        <h1 className={cx('header')}>Page not found!</h1>
        <span className={cx('info-message')}>
          We couldn&apos;t find the page you were looking for, or it doesn&apos;t exist.
        </span>
        {showNavigateToFeeds && (
          <Button
            mode={ButtonMode.PRIMARY}
            size={ButtonSize.SMALL}
            dataTestId="back-to-feeds-button"
            onClick={() => navigate(ROUTES.feed)}
          >
            Back to Feeds
          </Button>
        )}
      </div>
    </div>
  );
};

export default NotFound;
